import AnswerSearch from './answer_search';
export default AnswerSearch;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/search/index.js